/**@jsx jsx */
import { jsx } from 'theme-ui'
import Img, { GatsbyImageFluidProps, GatsbyImageFixedProps } from 'gatsby-image'
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react'

export interface FluidImageProps extends GatsbyImageFluidProps {
  src?: string
}
export interface FixedImageProps extends GatsbyImageFixedProps {
  src?: string
}
export type ImageProps = FluidImageProps | FixedImageProps
export const Image: React.FC<ImageProps> = (props) => {
  return props.src ? (
    <img
      {...(props as DetailedHTMLProps<
        ImgHTMLAttributes<HTMLImageElement>,
        HTMLImageElement
      >)}
      alt={props.alt}
    />
  ) : (
    <Img {...props} />
  )
}
